const getters = {
  cachedViews: (state) => state.tagViews.map((item) => item.name),
  roles: (state) => state.roles,
  individualizationSettings: (state) => (key) => state.userIndividualizationSettings[key]
}
export default getters
